var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalculatorBracketLeft = function SvgCalculatorBracketLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "75px",
    viewBox: "0 0 30 75",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "calculator-bracket-left")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculator-bracket-left",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4758852,9.34339719 C16.3809947,16.1746214 10.0159324,26.4350019 10.0159324,37.4919739 C10.0159324,48.5820536 16.3483888,58.8414308 27.3928885,65.6415539 L29.5102943,66.9447937 L24.0058295,74.9989967 L22.136426,73.852266 C12.0384848,67.6561079 5.5067062e-14,56.3172187 5.5067062e-14,37.4919739 C5.5067062e-14,18.6687356 12.0365087,7.32984643 22.1334618,1.132685 L23.9811281,7.10542736e-15 L29.6249089,8.0210953 L27.4758852,9.34339719 Z",
    fill: "#F0E6DC"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalculatorBracketLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calculator-bracket-left.218450a4.svg";
export { ForwardRef as ReactComponent };